import { render, staticRenderFns } from "./PhonesBulk.vue?vue&type=template&id=63582234"
import script from "./PhonesBulk.vue?vue&type=script&lang=ts"
export * from "./PhonesBulk.vue?vue&type=script&lang=ts"
import style0 from "./PhonesBulk.vue?vue&type=style&index=0&id=63582234&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports